import React, { createContext, ReactNode, useCallback, useContext, useMemo, useState } from 'react';

import { IFabConfig } from '../types/shell';

const DEFAULT_FAB_CONFIG: IFabConfig = {
  down: undefined,
  up: undefined,
  desktopFabEnabled: true,
};

interface IFabContext {
  fabConfig: IFabConfig;
  setFabConfig: (config: IFabConfig) => void;
  clearFabConfig: () => void;
}

const FabContext = createContext<IFabContext | undefined>(undefined);

export const FabProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [fabConfig, setFabConfig] = useState<IFabConfig>(DEFAULT_FAB_CONFIG);

  const clearFabConfig = useCallback(() => {
    setFabConfig(DEFAULT_FAB_CONFIG);
  }, []);

  const value = useMemo(
    () => ({
      fabConfig,
      setFabConfig,
      clearFabConfig,
    }),
    [fabConfig, clearFabConfig],
  );

  return <FabContext.Provider value={value}>{children}</FabContext.Provider>;
};

export const useFabContext = () => {
  const context = useContext(FabContext);
  if (!context) {
    throw new Error('useFabContext must be used within FabProvider');
  }

  return context;
};
